import QuoteInfo from './swapInterfaces/QuoteInfo';


export const failedQuotes = new QuoteInfo(0, 0);

export default {
  failedQuotes,
};
